import { api } from '../../lib/api';

export const INVOICE_STATUSES = [
  { value: 'Draft', label: 'Draft', tone: 'neutral' },
  { value: 'PendingApproval', label: 'In approval', tone: 'warning' },
  { value: 'Approved', label: 'Approved', tone: 'success' },
  { value: 'Disputed', label: 'Disputed', tone: 'warning' },
  { value: 'Paid', label: 'Paid', tone: 'brand' },
  { value: 'Cancelled', label: 'Cancelled', tone: 'danger' },
];

export const invoiceStatusMeta = (status) =>
  INVOICE_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

export const MATCH_STATUSES = [
  { value: 'NotMatched', label: 'Not matched', tone: 'neutral' },
  { value: 'Matched', label: 'Matched', tone: 'success' },
  { value: 'PriceVariance', label: 'Price variance', tone: 'warning' },
  { value: 'QuantityVariance', label: 'Qty variance', tone: 'warning' },
  { value: 'PriceAndQuantityVariance', label: 'Price + qty variance', tone: 'danger' },
];

export const matchStatusMeta = (status) =>
  MATCH_STATUSES.find((s) => s.value === status) || { value: status, label: status, tone: 'neutral' };

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const invoicesApi = {
  list: (params = {}) => api.get(`/supplier-invoices${toQuery(params)}`),
  apSummary: () => api.get('/supplier-invoices/ap-summary'),
  get: (id) => api.get(`/supplier-invoices/${id}`),
  listActivity: (id, params = {}) => api.get(`/supplier-invoices/${id}/activity${toQuery(params)}`),
  create: (payload) => api.post('/supplier-invoices', payload),
  save: (id, payload) => api.put(`/supplier-invoices/${id}`, payload),
  approve: (id, comment) => api.post(`/supplier-invoices/${id}/approve`, { comment: comment || null }),
  dispute: (id, reason) => api.post(`/supplier-invoices/${id}/dispute`, { reason: reason || null }),
  markPaid: (id, payload = {}) => api.post(`/supplier-invoices/${id}/pay`, payload),
  cancel: (id, reason) => api.post(`/supplier-invoices/${id}/cancel`, { reason: reason || null }),
};
